import { render, staticRenderFns } from "./CardProductRecylingIndex.vue?vue&type=template&id=16f17fa3&scoped=true&"
import script from "./CardProductRecylingIndex.vue?vue&type=script&lang=js&"
export * from "./CardProductRecylingIndex.vue?vue&type=script&lang=js&"
import style0 from "./CardProductRecylingIndex.vue?vue&type=style&index=0&id=16f17fa3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f17fa3",
  null
  
)

export default component.exports